// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2UBIN","productName":"Table_productName__3J25o"};